import { computed, Injectable, signal } from '@angular/core';
import {
  ConfirmDefaultPaymentMethodPopupText,
  Feature,
  PaymentPlan
} from '../data/auth-data.interface';

interface AuthState {
  puId: string;
  accessToken: string;
  refreshToken: string;
  rpId: string;
  rpName: string;
  email: string;
  mobilephone: string;
  brand: string;
  puNumber: number;
  paymentPlans: PaymentPlan[];
  features: Feature[];
  otpSent: boolean;
  baTransactionOwner: string;
  baTransactionFee: string;
  enableAMF: boolean;
  rpAMF: number;
  agreeToChargeAMF: boolean;
  confirmDefaultPaymentMethodPopupTextCc: ConfirmDefaultPaymentMethodPopupText | null;
  confirmDefaultPaymentMethodPopupTextBa: ConfirmDefaultPaymentMethodPopupText | null;
  defPayMtdType: { value: string; text: string } | null;
}

@Injectable({
  providedIn: 'root'
})
export class AuthStoreService {
  private state = signal<AuthState>({
    puId: '',
    accessToken: '',
    refreshToken: '',
    rpId: '',
    rpName: '',
    email: '',
    mobilephone: '',
    brand: '',
    puNumber: 0,
    paymentPlans: [],
    features: [],
    otpSent: false,
    baTransactionOwner: '',
    baTransactionFee: '',
    enableAMF: true,
    rpAMF: 0,
    agreeToChargeAMF: false,
    confirmDefaultPaymentMethodPopupTextCc: null,
    confirmDefaultPaymentMethodPopupTextBa: null,
    defPayMtdType: null
  });

  readonly puId = computed(() => this.state().puId);
  readonly accessToken = computed(() => this.state().accessToken);
  readonly refreshToken = computed(() => this.state().refreshToken);
  readonly isAuthenticated = computed(
    () => !!this.state().accessToken && !!this.state().refreshToken
  );
  readonly rpId = computed(() => this.state().rpId);
  readonly rpName = computed(() => this.state().rpName);
  readonly email = computed(() => this.state().email);
  readonly mobilephone = computed(() => this.state().mobilephone);
  readonly brand = computed(() => this.state().brand);
  readonly puNumber = computed(() => this.state().puNumber);
  readonly paymentPlans = computed(() => this.state().paymentPlans);
  readonly features = computed(() => this.state().features);
  readonly otpSent = computed(() => this.state().otpSent);
  readonly baTransactionOwner = computed(() => this.state().baTransactionOwner);
  readonly baTransactionFee = computed(() => this.state().baTransactionFee);
  readonly enableAMF = computed(() => this.state().enableAMF);
  readonly rpAMF = computed(() => this.state().rpAMF);
  readonly agreeToChargeAMF = computed(() => this.state().agreeToChargeAMF);
  readonly confirmDefaultPaymentMethodPopupTextCc = computed(
    () => this.state().confirmDefaultPaymentMethodPopupTextCc
  );
  readonly confirmDefaultPaymentMethodPopupTextBa = computed(
    () => this.state().confirmDefaultPaymentMethodPopupTextBa
  );
  readonly defPayMtdType = computed(() => this.state()?.defPayMtdType?.value);

  setState(partial: Partial<AuthState>) {
    this.state.update(state => ({
      ...state,
      ...partial
    }));
  }
}
